import { Outlet } from "react-router-dom";
import InactiveStudioSidebar from "../components/InactiveStudioSidebar";

export default function InactiveStudioLayout() {
  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900 m-0 p-0">
      <InactiveStudioSidebar />
      <div className="flex-1 flex flex-col overflow-hidden m-0 p-0">
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900 !m-0 !p-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
